import { useRuntimeConfig } from '#imports'

import { Locale, type Market, MarketCountryCode } from '@backmarket/http-api'

import { MARKETS } from '../config'

export function getMarkets(): Record<MarketCountryCode, Market> {
  let enableEsUsLocale = false
  // A try-catch block is required to handle cases where the Nuxt instance may not be available.
  try {
    const config = useRuntimeConfig().public
    enableEsUsLocale = config.FF_ENABLE_ES_US_LOCALE as boolean
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[nuxt-module-marketplace] Error from getMarkets', {
      err,
    })
  }

  const markets = { ...MARKETS }

  if (enableEsUsLocale) {
    markets[MarketCountryCode.US] = {
      ...markets[MarketCountryCode.US],
      locales: [...markets[MarketCountryCode.US].locales, Locale.es_US],
    }
  }

  return markets
}
